/**
 * Logo Component
 * Uses MUI Layers icon as the Restack logo
 */

import React from 'react';
import LayersRoundedIcon from '@mui/icons-material/LayersRounded';

export default function Logo({ sx, ...props }) {
  return (
    <LayersRoundedIcon
      sx={{
        fontSize: '1.5em',
        ...sx
      }}
      {...props}
    />
  );
}
